import { render, staticRenderFns } from "./BlockType1.vue?vue&type=template&id=c1d3a322&scoped=true&"
import script from "./BlockType1.vue?vue&type=script&lang=ts&"
export * from "./BlockType1.vue?vue&type=script&lang=ts&"
import style0 from "./BlockType1.vue?vue&type=style&index=0&id=c1d3a322&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1d3a322",
  null
  
)

export default component.exports